module.exports = __webpack_public_path__ + "static/media/noitem.6701727b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mywk/noitem.png
// module id = 2078
// module chunks = 4